// Material 3 Plain Tooltip
// Inverse surface container, 4px corners, body-small text. Wraps MUI Tooltip (same props).
(function () {
  const { Tooltip: MuiTooltip } = MaterialUI;

  function Tooltip({ title, children, placement = 'bottom', enterDelay = 500, ...props }) {
    return (
      <MuiTooltip
        title={title}
        placement={placement}
        enterDelay={enterDelay}
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: 'var(--m3-inverse-surface)',
              color: 'var(--m3-inverse-on-surface)',
              borderRadius: 'var(--m3-shape-extra-small)',
              font: 'var(--m3-type-body-small)',
              letterSpacing: '0.4px',
              px: 1,
              py: 0.5,
              m: '8px !important'
            }
          }
        }}
        {...props}
      >
        {children}
      </MuiTooltip>
    );
  }

  window.Components = window.Components || {};
  window.Components.Tooltip = Tooltip;
})();
